import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { env } from 'src/environments/environment';
import { LoadingSpinnerComponent } from './layouts/components/loading-spinner/loading-spinner.component';
import { ChatBubbleComponent } from './layouts/components/chat-bubble/chat-bubble.component';

@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet, LoadingSpinnerComponent, ChatBubbleComponent]
})
export class AppComponent implements OnInit {
  private router = inject(Router);

  ngOnInit() { 
    if (!env.production) {
      this.clearSessionOnDevReload();
    }
    this.hideSplashScreen();
  }

  private clearSessionOnDevReload() {
    const isReload = sessionStorage.getItem('app_initialized');
    const currentUrl = window.location.pathname;
    const isOAuthCallback = currentUrl.includes('/auth/microsoft') || 
                            currentUrl.includes('/auth/google');

    if (!isReload) {
      sessionStorage.setItem('app_initialized', 'true');

      // No limpiar nada si estamos en un callback OAuth
      if (isOAuthCallback) {
        console.log('🔧 [DEV] Callback OAuth detectado - Manteniendo sesión para procesamiento');
        return;
      }

      console.log('🔧 [DEV] Primera carga detectada - Limpiando sesión anterior...');

      const keysToRemove = ['user', 'auth_user', 'auth_token', 'loginTime'];
      keysToRemove.forEach(key => {
        if (localStorage.getItem(key)) {
          console.log(`   🗑️ Limpiando: ${key}`);
          localStorage.removeItem(key);
        }
      });

      const allKeys = Object.keys(localStorage);
      allKeys.forEach(key => {
        if (key.startsWith('microsoft_oauth_') || key.startsWith('google_oauth_')) {
          console.log(`   🗑️ Limpiando token OAuth: ${key}`);
          localStorage.removeItem(key);
        }
      });

      console.log('   ✅ Sesión limpiada - Usuario debe iniciar sesión nuevamente');

      if (!currentUrl.includes('/login') && 
          !currentUrl.includes('/register') &&
          !currentUrl.includes('/auth/microsoft') &&
          !currentUrl.includes('/auth/google')) {
        console.log('   🔀 Redirigiendo a /login...');
        this.router.navigate(['/login']);
      }
    } else {
      console.log('🔧 [DEV] Navegación dentro de la app - Manteniendo sesión');
    }
  }

  private hideSplashScreen() {
    const splashScreen = document.getElementById('vex-splash-screen');
    if (splashScreen) {
      splashScreen.style.opacity = '0';
      setTimeout(() => {
        splashScreen.remove();
      }, 300);
    }
  }
}